import FormHelperText from '@mui/material/FormHelperText';
import { DateTimePicker, DateTimePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TProps = DateTimePickerProps<any> & {
  name: string;
  helperText?: string;
};

export const RHFDateTimePicker = forwardRef<HTMLInputElement, TProps>((props, ref) => {
  const { name, helperText, sx, ...others } = props;

  const { control } = useFormContext();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onBlur, onChange, ...rest }, fieldState: { error } }) => {
          return (
            <>
              <DateTimePicker
                {...others}
                {...rest}
                onChange={value => {
                  onChange(value);
                  onBlur();
                }}
                name={name}
                inputRef={ref}
                sx={{
                  width: '100%',
                  ...sx,
                }}
              />

              {(!!error || helperText) && (
                <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
              )}
            </>
          );
        }}
      />
    </LocalizationProvider>
  );
});
